export const DomPurifyConstants = {
    get globalMessageConfiguration(): IDomPurifyConfiguration {
        return {
            allowedAttributes: ["href", "rel", "target"],
            allowedTags: ["#text", "a", "br", "em", "p", "strong", "u", "ol", "li", "ul"],
            keepContent: false,
        };
    },
};

export interface IDomPurifyConfiguration {
    allowedAttributes: string[] | undefined;
    allowedTags: string[] | undefined;
    keepContent: boolean | undefined;
}
